import type { ReactNode } from "react"
import { Stack } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import type { OrderPrintActions } from "../../../../../shared/components/orderChat/print/usePrintWithChatHistory"
import { HIDDEN_IN_PRINT } from "../../../../../shared/components/print/printPageOnly"
import type { MeetingServiceOrder } from "../../production/meetingService/meetingServiceTypes"

export type RenderPrintViewOrderMenu = (
    orderId: number,
    printActions?: OrderPrintActions,
    order?: MeetingServiceOrder,
) => ReactNode

const useStyles = makeStyles()(() => ({
    root: {
        ...HIDDEN_IN_PRINT,
    },
}))

type PrintViewOrderActionsProps = Readonly<{
    orderMenu?: ReactNode
    className?: string
}>

export function PrintViewOrderActions({ orderMenu, className }: PrintViewOrderActionsProps) {
    const { classes, cx } = useStyles()

    if (!orderMenu) return null

    return (
        <Stack direction="row" alignItems="center" className={cx(classes.root, className)}>
            {orderMenu}
        </Stack>
    )
}
